import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams } from "react-router-dom";
import Footer from "./Footer";

import worker1 from "../images/worker1.jpg";
import worker2 from "../images/worker2.jpg";
import worker3 from "../images/worker3.jpg";
import worker4 from "../images/worker4.jpg";
import worker5 from "../images/worker5.jpg";
import worker6 from "../images/worker6.jpg";
import teamImage from "../images/team.jpg";
import image1 from "../images/together-office.jpg";

const members = [
  {
    id: 1,
    name: "Michele Morrone",
    role: "Kitchen Cleaner",
    photo: worker1,
    whatsapp: "94771234567",
    description: "Michele is an excellent kitchen cleaner with a friendly attitude and great attention to detail.",
    skills: [
      { name: "Repairs", percent: 80 },
      { name: "Cleaning", percent: 95 },
      { name: "Organization", percent: 90 },
    ],
  },
  {
    id: 2,
    name: "Luigi Rossi",
    role: "Bathroom Cleaner",
    photo: worker2,
    whatsapp: "94771234568",
    description: "Luigi is meticulous and ensures spotless bathrooms every time.",
    skills: [
      { name: "Cleaning", percent: 92 },
      { name: "Organization", percent: 85 },
    ],
  },
  {
    id: 3,
    name: "Sara Bianchi",
    role: "Living Room Cleaner",
    photo: worker3,
    whatsapp: "94771234569",
    description: "Sara keeps your living room spotless with great attention to detail.",
    skills: [
      { name: "Cleaning", percent: 90 },
      { name: "Organization", percent: 88 },
    ],
  },
  {
    id: 4,
    name: "Marco Verdi",
    role: "Window Cleaner",
    photo: worker4,
    whatsapp: "94771234570",
    description: "Marco is our expert in streak-free window cleaning.",
    skills: [
      { name: "Cleaning", percent: 95 },
      { name: "Safety", percent: 85 },
    ],
  },
  {
    id: 5,
    name: "Anna Neri",
    role: "Garden Cleaner",
    photo: worker5,
    whatsapp: "94771234571",
    description: "Anna makes your garden shine and tidy every day.",
    skills: [
      { name: "Gardening", percent: 90 },
      { name: "Cleaning", percent: 85 },
    ],
  },
  {
    id: 6,
    name: "Luca Gallo",
    role: "Floor Cleaner",
    photo: worker6,
    whatsapp: "94771234572",
    description: "Luca specializes in floor cleaning and polishing.",
    skills: [
      { name: "Floor Polishing", percent: 95 },
      { name: "Cleaning", percent: 90 },
    ],
  },
];

export default function TeamDetail() {
  const { id } = useParams();
  const member = members.find((m) => m.id === parseInt(id));

  const [formData, setFormData] = useState({ name: "", email: "", message: "", clientTime: "" });
  const [availableFrom, setAvailableFrom] = useState("10:00");
  const [availableTo, setAvailableTo] = useState("18:00");
  const [statusMsg, setStatusMsg] = useState("");
  const [statusClass, setStatusClass] = useState("");

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!member || !formData.clientTime) {
      alert("Please fill all fields and select a time ⏰");
      return;
    }

    let availabilityStatus = "";
    if (formData.clientTime >= availableFrom && formData.clientTime <= availableTo) {
      availabilityStatus = "AVAILABLE ✅";
      setStatusMsg(`${member.name} is AVAILABLE`);
      setStatusClass("text-success fw-bold mt-2");
    } else {
      availabilityStatus = "NOT AVAILABLE ❌";
      setStatusMsg(`${member.name} is NOT AVAILABLE`);
      setStatusClass("text-danger fw-bold mt-2");
    }

    const text = `Hello ${member.name},%0AName: ${formData.name}%0AEmail: ${formData.email}%0AMessage: ${formData.message}%0AWorker Availability: From ${availableFrom} To ${availableTo}%0AClient Preferred Time: ${formData.clientTime}%0AStatus: ${availabilityStatus}`;
    window.open(`https://wa.me/${member.whatsapp}?text=${text}`, "_blank");
  };

  if (!member) return <p className="text-center mt-5">Member not found</p>;

  return (
    <>
      {/* Hero */}
      <section className="contact-hero" style={{ backgroundImage: `url(${image1})` }}>
        <div className="contact-content">
          <h1 className="hero-title">Team Detail</h1>
          <nav className="breadcrumb-center">
            <a href="/"><b>Home</b></a> ›  
            <span className="active">Team Detail</span>
          </nav>
        </div>
      </section>

      <div className="container py-5">
        <div className="row g-4">
          {/* Left Column */}
          <div className="col-md-6 text-center">
            <img src={member.photo} alt={member.name} className="mb-3" style={{ width: "180px", height: "180px", objectFit: "cover", borderRadius: "50%", border: "5px solid #0da6acff" }} />
            <h4>{member.name}</h4>
            <p className="text-muted">{member.role}</p>

            {/* Contact Form */}
            <h5 className="fw-bold mt-4 mb-3 text-primary">Contact & Availability</h5>
            <form onSubmit={handleSubmit} className="text-start">
              <input type="text" name="name" placeholder="Your Name" className="form-control mb-2" value={formData.name} onChange={handleChange} required />
              <input type="email" name="email" placeholder="Your Email" className="form-control mb-2" value={formData.email} onChange={handleChange} required />
              <textarea name="message" placeholder="Your Message" className="form-control mb-2" rows="3" value={formData.message} onChange={handleChange} required />

              <div className="card p-3 mt-3">
                <h6 className="text-primary mb-2">👩‍💻 Worker sets available time</h6>
                <div className="row g-2 mb-2">
                  <div className="col-md-6">
                    <label>Available From</label>
                    <input type="time" className="form-control" value={availableFrom} onChange={(e) => setAvailableFrom(e.target.value)} />
                  </div>
                  <div className="col-md-6">
                    <label>Available To</label>
                    <input type="time" className="form-control" value={availableTo} onChange={(e) => setAvailableTo(e.target.value)} />
                  </div>
                </div>
                <input type="time" name="clientTime" className="form-control" value={formData.clientTime} onChange={handleChange} required />
              </div>

              <button type="submit" className="btn btn-success w-100 mt-3" style={{ backgroundColor: "rgb(61, 4, 68)", color: "#fff" }}>
                <i className="fa-brands fa-whatsapp"></i> Send via WhatsApp 💬
              </button>
            </form>

            <div className={statusClass}>{statusMsg}</div>
          </div>

          {/* Right Column */}
          <div className="col-md-6 text-start">
            <h5 className="fw-bold text-primary">About Me</h5>
            <p className="text-secondary">{member.description}</p>

            <h5 className="fw-bold text-primary mt-3">My Skills</h5>
            {member.skills.map((skill, i) => (
              <div key={i} className="mb-3">
                <div className="d-flex justify-content-between">
                  <span>{skill.name}</span>
                  <span>{skill.percent}%</span>
                </div>
                <div className="progress" style={{ height: "8px" }}>
                  <div className="progress-bar bg-info" style={{ width: `${skill.percent}%` }}></div>
                </div>
              </div>
            ))}

            <div className="mt-4">
              <img src={teamImage} alt="Our Team" className="img-fluid rounded shadow mb-3" />
              <h5 className="fw-bold text-primary">Our Team</h5>
              <p className="text-secondary">Our team is dedicated to providing top-notch services with professionalism and care.</p>
            </div>
          </div>
        </div>
      </div>
{/* Cleaning Animations Section */}
<div className="cleaning-wrapper mt-3">

  {/* 1) Wipe Shine Animation */}
  <div className="clean-wipe mb-3">
    Cleaning in Progress...
  </div>

  {/* 2) Broom Sweeping Animation */}
  <div className="broom-area mb-3">
    🧹
  </div>

  {/* 3) Floating Cleaning Bubbles */}
  <div className="bubble-clean mb-3">
    <div className="bubble"></div>
    <div className="bubble"></div>
    <div className="bubble"></div>
  </div>

  {/* 4) Mop Cleaning Loader */}
  <div className="clean-loader mb-3">
    <span className="mop">🧽</span>
    <p>Cleaning...</p>
  </div>

</div>

      <Footer />
    </>
  );
}

